export class SignupService {
  constructor(AppUserService) {
    "ngInject";
    this.AppUserService = AppUserService;
  }

  signupUser(userInfo) {
    return this.AppUserService.signupUser(userInfo);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/signup/signup.service.js